import { create } from 'zustand';

interface TrialContactsMessageState {
  setShowContactsMsg: (show: boolean) => void;
  setShowLocationsMsg: (show: boolean) => void;

  showContactsMsg: boolean;
  showLocationsMsg: boolean;
}

export const trialContactsMessageStore = create<TrialContactsMessageState>((set) => ({
  showContactsMsg: false,
  setShowContactsMsg: (showContactsMsg: boolean) => set(() => ({ showContactsMsg })),

  showLocationsMsg: false,
  setShowLocationsMsg: (showLocationsMsg: boolean) => set(() => ({ showLocationsMsg })),
}));
